function Mission() {
  return (
    <>
      <section className="p-6 lg:px-24 lg:py-12 flex flex-col gap-6">
        <div className="relative rounded-xl w-full lg:h-[400px] flex flex-col overflow-hidden">
          <img
            className="hidden lg:block scale-110"
            src="https://magazyn.drzewus.pl/wp-content/uploads/2025/03/mulczowanie-rownanie-terenu-minikoparka-mulczowanie-Large-1.jpeg"
            alt="Mulczowanie i równanie terenu minikoparką - Drzewus"
          />
          <div className="bg-green lg:top-0 lg:right-12 rounded-b-xl p-12 lg:absolute max-w-[600px] flex flex-col items-start justify-center text-left gap-2">
            <h2 className="uppercase text-white text-xl">
              Nasza misja i wizja
            </h2>
            <h3 className="text-3xl lg:text-5xl text-white">
              Twoja działka jeszcze piękniejsza
            </h3>
            <p className="text-white text-left">
              Przy zmianach w ogrodzie liczy się pomysłowość i wyobraźnia. Nasza
              zdolność do wizualizacji terenu pozwala na niepowtarzalne
              rozwiązania.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Mission;
